import { Menu, useCheckboxGroup } from "@chakra-ui/react"
import type { ComponentProps } from "react"
import { FilterOption } from "./types"

export type OnChangeFilterValue = (value: FilterOption[]) => void

function FilterOptions({
  value,
  onChange
}: {
  value: FilterOption[]
  onChange: OnChangeFilterValue
}) {
  // TODO: base options off of the filter type, but for now we're just
  // going to handle the "any" case.

  const group = useCheckboxGroup({
    value,
    onValueChange: (nextValue: string[]) => {
      onChange(nextValue as FilterOption[])
    }
  })

  return (
    <Menu.ItemGroup>
      {/* <Menu.ItemGroupLabel></Menu.ItemGroupLabel> */}
      {["any"].map((option) => {
        const itemProps = group.getItemProps({ value: option }) as Omit<
          ComponentProps<typeof Menu.CheckboxItem>,
          "children" | "value"
        >

        return (
          <Menu.CheckboxItem key={option} value={option} {...itemProps}>
            is ANY
            <Menu.ItemIndicator />
          </Menu.CheckboxItem>
        )
      })}
    </Menu.ItemGroup>
  )
}

export default FilterOptions
